import styled from 'styled-components'
import Div from 'components/Div'
import breakpoint from 'tools/styled-components-breakpoint'
import { colors, dropShadows, padding, paddingSizes, dropShadowVariations, borderRadiusSizes } from 'theme/default'

const Card = styled(Div).attrs(() => ({
  className: '__card',
  borderRadius: borderRadiusSizes.medium
}))`
  padding: ${padding[paddingSizes.small]};
  box-shadow: ${dropShadows[dropShadowVariations.light]};
  background-color: ${props => props.theme.colorContainerColor};
  ${breakpoint('desktop')`
    padding: ${padding[paddingSizes.medium]};
  `}
  & .__card {
    box-shadow: none;
    border: 1px solid ${props => props.theme.colorLinesAndBorders};
  }
`
Card.propTypes = Div.propTypes
Card.defaultProps = {
  theme: {
    colorContainerColor: colors.container,
    colorLinesAndBorders: colors.separator
  }
}

export default Card
